import React, { useEffect, useState } from "react";

const LeadHistoryModal = ({ leadId, onClose }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (leadId) fetchHistory();
  }, [leadId]);

  const fetchHistory = async () => {
    try {
      const res = await fetch(
        `https://api.propertygalleria.in/master/api/api/leads/${leadId}/history`
      );
      const json = await res.json();

      if (json.success) {
        setHistory(json.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-end",
        zIndex: 999,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 900,
          height: "80%",
          background: "#fff",
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          padding: 20,
          overflowY: "auto",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <h3 style={{ margin: 0, color: "#1F2937" }}>
            Lead History
          </h3>

          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              fontSize: 20,
              cursor: "pointer",
              color: "#6B7280",
            }}
          >
            ✕
          </button>
        </div>

        {/* Content */}
        {loading ? (
          <div style={{ textAlign: "center", marginTop: 40 }}>
            Loading...
          </div>
        ) : history.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              marginTop: 40,
              color: "#9CA3AF",
            }}
          >
            No history found
          </div>
        ) : (
          history.map((item, index) => (
            <div
              key={item.id}
              style={{
                display: "flex",
                marginBottom: 25,
              }}
            >
              {/* Timeline Left */}
              <div
                style={{
                  width: 30,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: 6,
                    background: "#8b306d",
                  }}
                />

                {index !== history.length - 1 && (
                  <div
                    style={{
                      width: 2,
                      flex: 1,
                      background: "#E5E7EB",
                      marginTop: 2,
                    }}
                  />
                )}
              </div>

              {/* Timeline Content */}
              <div
                // style={{
                //   flex: 1,
                //   background: "#F9FAFB",
                //   padding: 15,
                //   borderRadius: 12,
                // }}
                style={{
  flex: 1,
  background: "#fff",
  padding: 14,
  borderRadius: 12,
  border: "1px solid #eee",
  boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
}}
              >
                <div
                  style={{
                    fontWeight: 600,
                    color: "#8b306d",
                    marginBottom: 6,
                      fontSize: 13,
                  }}
                >
                  {item.old_status
                    ?.replace("_", " ")
                    .toUpperCase()}{" "}
                  ➜{" "}
                  {item.new_status
                    ?.replace("_", " ")
                    .toUpperCase()}
                </div>

                {item.remarks && (
                  <div
                    style={{
                      color: "#374151",
                      marginBottom: 8,
                    }}
                  >
                    {item.remarks}
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                  }}
                >
                  <div style={{ color: "#42987e" }}>
                    {item.agent_name}
                  </div>

                  <div style={{ color: "#6B7280" }}>
                    {new Date(
                      item.created_at
                    ).toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default LeadHistoryModal;